import React, { useState, useRef, useEffect } from "react";
import useClickOutside from "../../../../components/Custom_Hooks/useClickOutsSide";
import { useDispatch, useSelector } from "react-redux";
import {
  closeModal,
  contraVoucherCreate,
  openModal,
  serialNumberList,
} from "../../../../redux/actions/action-creator";
import { useInputActionVoucher } from "../../../../components/Custom_Hooks/useInputActionVoucher";
import InputField from "../../../../components/Input/InputField";
import DropdownLayout_1 from "../../../../components/Dropdown/DropdownLayout_1";
import {
  prepareFormData,
  useFormHandler,
} from "../../../../components/Custom_Hooks/useFormHandler";
import Form from "../../../../components/Form/Form";
import MasterCreationFooter from "../../../../components/Footer/Master_Footer/MasterCreationFooter";
import {
  currencyFormate,
  getDateInFormate,
} from "../../../../components/Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import Total_Amount_Row from "../../../../components/Total_Amount/Total_Amount_Row";
import { JournalDynamicInputRow } from "./JournalDynamicInputRow";

const Journal = ({
  loading_voucher,
  data,
  setData,
  contra_account_ledger_list,
  handleChange,
  handleBlur,
  handleFocus,
  handleKeyDown,
  handleKeyDownItem,
  handleItemUpdate,
  handleDynamicFocus,
  handleDynamicBlur,
  handleDropdownClick,
  handleDropdownDynamicClick,
  handleFocusReset,
  setSubmitConfirm,
  submitConfirm,
  inputRefs,
  dynamicInputRef,
  handleSubmit,
  loading,
  modal_state,
}) => {
  // Add useEffect to focus on create_date when component loads
  useEffect(() => {
    if (inputRefs?.create_date?.current) {
      setTimeout(() => {
        inputRefs.create_date.current.focus();
        if (inputRefs.create_date.current.value) {
          inputRefs.create_date.current.setSelectionRange(0, inputRefs.create_date.current.value.length);
        }
      }, 100);
    }
  }, [inputRefs?.create_date]);

  const inputFields = [
    {
      label: "",
      name: "serial_no",
      type: "text",
      isRequired: true,
      isDisabled: true,
    },
    {
      label: "Date",
      name: "create_date",
      type: "text",
      isRequired: true,
      isDisabled: false,
    },
    {
      label: "Narration",
      name: "narration",
      type: "text",
      isRequired: true,
      isDisabled: false,
    },
  ];



  const TableHeader = () => {
    return (
      <div className="row p-0 m-0 mb-1 border_2_2px_top border_2_1px_bottom  heading_dyn_creation_data">
           <div
        className="col-1 p-0 m-0 pe-1 font_size font-weight-bold "
        style={{ textAlign: "right" }}
      >
        
      </div>
      <div
        className="col-4 p-0 m-0 ps-2 font_size font-weight-bold"
        style={{ textAlign: "left" }}
      >
        Particulars
      </div>
      <div
        className="col-3 p-0 m-0 font_size font-weight-bold"
        style={{ textAlign: "left" }}
      ></div>
      <div
        className="col-2 p-0 m-0 pe-1 font_size font-weight-bold "
        style={{ textAlign: "right" }}
      >
        Debit
      </div>
      <div
        className="col-2 p-0 m-0 pe-1 font_size font-weight-bold "
        style={{ textAlign: "right" }}
      >
        Credit
      </div>
    </div>
    )
  }


  return (
    <Form
      handleSubmit={handleSubmit}
      handleKeyDown={handleKeyDown}
      submitConfirm={submitConfirm}
      handleFocusReset={handleFocusReset}
      title={"Accounting Voucher Creation"}
      loading={loading || loading_voucher}
      col="col-12"
      Footer={MasterCreationFooter}
    >
      <div className="row p-0 m-0 mb-1">
        <div className="col-6">
          <div className="d-flex justify-content-between align-item-center">
            <label className="lab_voucher_entry" style={{ width: "35%" }}>
              {data?.voucher_type_name} No
            </label>
            <label>:</label>
            {inputFields
              .slice(0, 1)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, autoFocus },
                  index
                ) => (
                  <input
                    style={{ fontSize: 13, fontWeight: "bold", width: "100%" }}
                    type={type}
                    disabled={true}
                    name={name}
                    id={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                )
              )}
          </div>
        </div>
        <div className="col-6">
          <div className="row justify-content-end">
            <div className="col-6 d-flex justify-content-end">
              {inputFields
                .slice(1, 2)
                .map(({ label, name, type, isRequired, autoFocus }, index) => (
                  <>
                  <label className="pe-2">{data?.day_name}</label>
                  <input
                    style={{
                      fontSize: 13,
                      textAlign: "right",
                      fontWeight: "bold",
                      width: "38%",
                      paddingRight: "2px",
                    }}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    onChange={handleChange}
                    onKeyUp={handleChange}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                    autoFocus={autoFocus}
                  />
                  </>
                ))}
            </div>
          </div>
        </div>
      </div>
      <TableHeader />
      <div
        className="row p-0 m-0"
        style={{ height: "60vh", overflowY: "scroll" }}
      >
        <div className="col-12 p-0 m-0">
          <JournalDynamicInputRow
            setValueLoop={setData}
            valueLoop={data}
            handleChange={handleItemUpdate}
            handleFocus={handleDynamicFocus}
            handleBlur={handleDynamicBlur}
            handleDropdownDynamicClick={handleDropdownDynamicClick}
            inputRefs={dynamicInputRef}
            narr_ref={inputRefs}
            // dropList={[
            //   { id: "ed", ledger_name: "End of List" },
            //   ...contra_account_ledger_list,
            // ]}
          />
        </div>
      </div>

      <div className="row p-0 m-0" style={{ width: "100%" }}>
        <div className="col-6 m-0 p-0 ps-1 text-start  border-dark">
          {inputFields
            .slice(3)
            .map(({ label, name, type, isRequired }, index) => (
              <>
                <label>{label} </label>
                <div className="d-flex justify-content-between align-item-center">
                  <textarea
                    style={{ height: "7.5vh" }}
                    key={index}
                    lable={label}
                    className="narration_input"
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    onKeyUp={handleChange}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                  />
                </div>
              </>
            ))}
        </div>
        <Total_Amount_Row data={data} />
      </div>
    </Form>
  );
};

export default Journal;


